import { useOrgStore } from '@/stores/org-store';
import { Org } from '@/types';
import { apiRequest } from '@/utils/api-request';

export const getOrgInfo = async (id?: string) => {
  const orgId = id || useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest<{ data: Org; detail?: string }>({
    url: `/organizations/${orgId}`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to get org info' };
  }

  return response;
};
